import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AddCircleBlue, CustomDelete, FullTable, Loader, NoItemsYet } from 'components';
import { appointmentActions, formActions, noteActions, httpRequestsOnSuccessActions } from 'store';
import { FindLoad, FindSuccessItem, Images, PermissionList, useModal } from 'utils';
import { useFutureApptWarning } from './useFutureApptWarning';
import { apptNotesBody, apptNotesHead, noteEnums, noteNotYet } from './constants';
import { RequestNoteUpdate } from '../../../../client/clientSingle/core/notes/requestNoteUpdate';
import { NoteInfo } from '../../../../../components/modal/notes/noteInfo';
import { CreateAppFormNote } from './createAppFormNote';
import { formBuilderStatusEnums } from 'pages/forms/constants';

const ACTION_TYPE = 'DELETE_APPT_NOTE';
const ADD_EDIT_ACTION_TYPE = 'ADD_EDIT_APPT_NOTE';
const GET_NOTES_ACTION_TYPE = 'GET_GLOBAL_NOTES';
const APPT_ON_MODEL = 'Appt';

export const ApptNotes = ({ item }) => {
    const { open, close } = useModal();
    const dispatch = useDispatch();
    const allNotes = useSelector((state) => state.note?.notes?.data) || [];
    const noteList = allNotes
        .filter((note) => note?.type === noteEnums.OFFICE_NOTES)
        .map((note) => ({ ...note, createdDate: note?.created }));

    const deleteSuccess = FindSuccessItem(ACTION_TYPE);
    const addEditSuccess = FindSuccessItem(ADD_EDIT_ACTION_TYPE);
    const loader = FindLoad(GET_NOTES_ACTION_TYPE);

    const getNotes = (load) => {
        if (item?.id) {
            dispatch(noteActions.getGlobalNotes(item.id, APPT_ON_MODEL, { limit: 100 }, load));
        }
    };

    useEffect(() => {
        dispatch(formActions.resetForms());
        dispatch(formActions.getForms({ model: noteEnums.OFFICE_NOTES, status: formBuilderStatusEnums.PUBLISHED }));
    }, []);

    useEffect(() => {
        getNotes();
    }, [item?.id]);

    useEffect(() => {
        if (deleteSuccess || addEditSuccess) {
            getNotes('noLoad');
            [ACTION_TYPE, ADD_EDIT_ACTION_TYPE].forEach((type) => dispatch(httpRequestsOnSuccessActions.removeSuccess(type)));
        }
    }, [deleteSuccess, addEditSuccess]);

    const handleClickActions = (note, name) => {
        if (name === 'deleteNote') {
            open(
                <CustomDelete
                    text="Are you sure you want to delete this note? This action cannot be undone."
                    info="Delete Note"
                    handleDel={() => dispatch(appointmentActions.deleteApptNote(item?.id, note?.id, noteEnums?.OFFICE_NOTES))}
                    actionType={ACTION_TYPE}
                    body={
                        <div className="deleting-client-info-box" style={{ alignItems: 'flex-start' }}>
                            <img style={{ marginTop: '3px' }} src={Images.editBlack} alt="icon" />
                            <p style={{ fontWeight: 400 }}>{note?.template?.title}</p>
                        </div>
                    }
                />
            );
        }
        if (name === 'editNote' || name === 'edit') {
            open(<CreateAppFormNote info={note} apptId={item?.id} noteType={noteEnums?.OFFICE_NOTES} />, {
                styles: { bodyStyle: { padding: '24px 48px' } },
            });
        }
        if (name === 'requestUpdate') {
            open(<RequestNoteUpdate afterSuccess={() => {
            }} info={note} appt={{ ...item, apptId: item?.id }} single={true} />, {
                styles: { bodyStyle: { padding: '24px 48px' } },
            });
        }
    };

    const checkFutureDateAndRun = useFutureApptWarning(item);

    const handleAddNote = () => {
        checkFutureDateAndRun(() => open(<CreateAppFormNote apptId={item?.id} noteType={noteEnums?.OFFICE_NOTES} />, {
            styles: { bodyStyle: { padding: '24px 48px' } },
        }));
    };

    return (
        <div>
            <div className="space-between-align-center">
                <p className="note-table-title">Notes</p>
                <AddCircleBlue
                    type="button"
                    text={'Add Note'}
                    handleClick={handleAddNote}
                />
            </div>

            {loader?.length ? (
                <Loader />
            ) : noteList?.length ? (
                <FullTable
                    margin={'16px 0 0'}
                    height={'medium'}
                    head={apptNotesHead}
                    body={apptNotesBody(item, null, noteEnums?.OFFICE_NOTES)}
                    list={noteList}
                    handleClickButton={(value, name) => handleClickActions(value, name)}
                    handleClick={(id, note) =>{
                        open(
                            <NoteInfo
                                note={note}
                                handleAction={(value, name) => handleClickActions(value, name)}
                                permissions={[PermissionList.APPT_UPDATE_NOTES?.code]}
                                notCheckUser={true}
                            />, {
                                styles: { bodyStyle: { padding: '24px 48px' } },
                            })
                    }}
                    notYet={noteNotYet}
                    activeRowId={''}
                />
            ) : (
                <NoItemsYet
                    height={noteNotYet?.height}
                    text={noteNotYet.title}
                    subTitle={noteNotYet.subTitle}
                    image={noteNotYet.image}
                />
            )}
        </div>
    );
};
